import { useTrackItemSelectAnalytics } from '../../hooks/bi/useTrackItemSelectAnalytics';
import { createHOCWithHookInside } from '../createHOCWithHookInside';

/**
 * @deprecated use "useTrackItemSelectAnalytics"
 */
export const withItemSelectAnalytics = createHOCWithHookInside('WithItemSelectAnalytics', useTrackItemSelectAnalytics);
